import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { firstValueFrom, lastValueFrom } from "rxjs";

import { IAuthenticationService, UserIdentity } from "@logex/framework/lg-application";

import { SharedConfigService } from "@codman/shared/util-logex-framework-setup";

import { Auth0AuthorizationService } from "./auth0-authorization.service";

@Injectable()
export class Auth0AuthenticationService implements IAuthenticationService {
    private _httpClient = inject(HttpClient);
    private _configService = inject(SharedConfigService);
    private _authorizationService = inject(Auth0AuthorizationService);

    get loggedIn(): boolean {
        return this._authorizationService.loggedIn ?? false;
    }

    get user(): UserIdentity {
        const user = this._authorizationService.currentUserProfile;
        return {
            id: user?.email ?? "",
            login: user?.email ?? "",
            name: user?.name ?? "",
        };
    }

    login(): Promise<boolean> {
        return this._authorizationService.login();
    }

    isLoggedIn(): Promise<boolean> {
        return firstValueFrom(this._authorizationService.isAuthenticated$);
    }

    logout(): Promise<void> {
        return this._authorizationService.logout();
    }

    endImpersonation(): Promise<void> {
        const apiUrl = this._configService.getConfiguration()?.authApiUrl;
        return lastValueFrom(this._httpClient.delete<void>(`${apiUrl}api/v3/impersonation/stop`));
    }
}
